export const isLeapYear = (yyyy: number): boolean =>
  (yyyy % 4 === 0 && yyyy % 100 !== 0) || yyyy % 400 === 0;
